import i18n from 'i18next';
import { message } from '@linktivity/link-ui';
import { Firebase } from '@linktivity/link-utils';
import { BaseAuth } from '@link/share/stores';
export type {
  User,
  UserCredential,
  MultiFactorError
} from '@linktivity/link-utils';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET
};

class ShareAuth extends Firebase {
  constructor(auth: BaseAuth) {
    super(firebaseConfig);

    this.auth.onAuthStateChanged(user => {
      if (user) {
        auth.setUser(user);
      } else {
        auth.clearUser();
      }
    });
  }

  changePassword(oldPassword: string, newPassword: string): Promise<boolean> {
    return super.changePassword(oldPassword, newPassword);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showErrorMessage(error: any) {
    const errorCode = error.code;
    let errorMessage = error.message;
    if (i18n.exists(`share.firebase.${errorCode}`)) {
      errorMessage = i18n.t(`share.firebase.${errorCode}`);
    }
    message.error(errorMessage);
  }
}
export default ShareAuth;
